import { shallowRef, onMounted } from "vue";
import { u as useCaptureEvent } from "./useCaptureEvent-90d008ac.mjs";
const useActiveElement = () => {
  const activeEl = shallowRef();
  const updateActiveElement = () => {
    activeEl.value = document.activeElement;
  };
  onMounted(updateActiveElement);
  useCaptureEvent("focus", updateActiveElement);
  useCaptureEvent("blur", updateActiveElement);
  return activeEl;
};
export {
  useActiveElement as u
};
//# sourceMappingURL=useActiveElement-6965d0a8.mjs.map
